import { useMemo } from 'react';
import styles from './DecayParticles.module.css';

const PARTICLE_COUNT = 15;

const DecayParticles = (): React.ReactElement => {
  const particles = useMemo(
    () =>
      Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
        id: i,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 10}s`,
        duration: `${8 + Math.random() * 12}s`,
        size: `${2 + Math.random() * 3}px`,
      })),
    [],
  );

  return (
    <div className={styles.container} aria-hidden="true">
      {particles.map((p) => (
        <div
          key={p.id}
          className={styles.particle}
          style={{
            left: p.left,
            animationDelay: p.delay,
            animationDuration: p.duration,
            width: p.size,
            height: p.size,
          }}
        />
      ))}
    </div>
  );
};

export { DecayParticles };
